import { serializeUrl } from '../internal/serialize-url'
import { PrestudyRoomParams, prestudyRoomUrlParamsSchema } from '../schemas/prestudyroom-params'

export const buildPrestudyRoomUrl = (params: PrestudyRoomParams): string => {
  const { roomId, referrer, originals } = prestudyRoomUrlParamsSchema.parse(params)
  const query: Record<string, string | number> = {}

  if (referrer) {
    query.referrer = referrer
  }

  if (originals) {
    for (const [key, value] of Object.entries(originals)) {
      // eslint-disable-next-line eqeqeq
      if (value != null) {
        query[key] = value as string | number
      }
    }
  }

  return serializeUrl(`/prestudyroom/${roomId}`, { required: {}, optional: query })
}
